/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListModelCatalogOrgAccessRequest = {
  orgId: string;
};

/** @internal */
export const ListModelCatalogOrgAccessRequest$inboundSchema: z.ZodType<
  ListModelCatalogOrgAccessRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  orgId: z.string(),
});
/** @internal */
export type ListModelCatalogOrgAccessRequest$Outbound = {
  orgId: string;
};

/** @internal */
export const ListModelCatalogOrgAccessRequest$outboundSchema: z.ZodType<
  ListModelCatalogOrgAccessRequest$Outbound,
  z.ZodTypeDef,
  ListModelCatalogOrgAccessRequest
> = z.object({
  orgId: z.string(),
});

export function listModelCatalogOrgAccessRequestToJSON(
  listModelCatalogOrgAccessRequest: ListModelCatalogOrgAccessRequest,
): string {
  return JSON.stringify(
    ListModelCatalogOrgAccessRequest$outboundSchema.parse(
      listModelCatalogOrgAccessRequest,
    ),
  );
}
export function listModelCatalogOrgAccessRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListModelCatalogOrgAccessRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListModelCatalogOrgAccessRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListModelCatalogOrgAccessRequest' from JSON`,
  );
}
